import React, { useEffect, useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import Button from "../../components/button";
import Impact from "../../components/impact";

const lanMainContainer = ({ mainData, classOption = "" }) => {
    return (
        <div className={`funfact-section position-relative ${classOption}`}>
            <div className="my-10 y-background-color">
                <div className="col-xl-12 col-lg-12 mx-auto text-center pt-1">
                    <div className="title-section title-section text-center p-5">
                        <h4 className="font-weight-bold g-color">
                            <b>
                                Professional growth cannot happen without
                                personal growth.
                                <br />
                                We give you both.
                            </b>
                        </h4>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row mb-5 ">
                    <div className="col-xl-12 col-lg-12 mx-auto text-center">
                        <div className="title-section title-section text-center mb-5">
                            <p className="pb-4 ">
                                Companies have been defining growth as
                                promotions and salary increments for decades.
                                It’s time to outgrow that definition. Work is
                                merely a subset of life. NeoGrowth gives you
                                life skills, not just professional skills.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row text-center justify-content-center mb-5">
                    {mainData[0].contactUs &&
                        mainData[0].contactUs.map((single, key) => {
                            return (
                                <div key={key} className={single.classOption}>
                                    <div className="fanfact text-md-left text-center">
                                        <img
                                            src={
                                                process.env.PUBLIC_URL +
                                                single.image
                                            }
                                            alt="images"
                                            width={single.width}
                                        />
                                        <p className="mt-3">{single.title}</p>
                                    </div>
                                </div>
                            );
                        })}
                </div>

                <div className="row mb-5 ">
                    <div className="col-xl-12 col-lg-12 mx-auto text-center">
                        <div className="title-section title-section text-center">
                            {/* <span className="sub-title"></span> */}
                            {/* <h3 className="font-weight-bold g-color pb-4">
                                <b>Join Us</b>
                            </h3> */}
                            <p className="pb-4 b-color">
                                Every story here is custom-built. If you are
                                ready to take the next leap in your career and
                                grow with us, check out our current job
                                openings.
                            </p>

                            <Button
                                classOption=" btn btn-sm btn-primary btn-hover-primary"
                                text="Explore Opportunities"
                                path="job-opening"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-3 y-background-color">
                <div className="col-xl-12 col-lg-12 mx-auto text-center ">
                    <div className="title-section title-section text-center">
                        <h3 className="title pb-1 g-color">
                            <span>
                                <i>Second Career</i>
                            </span>
                            <span className="b-color ">
                                <i> for Women</i>
                            </span>
                        </h3>

                        <p className="pb-1 d-color">
                            An initiative which creates opportunities for women
                            returning to the workforce after a career break.
                        </p>
                        <Button
                            classOption=" btn btn-sm btn-primary btn-hover-primary mb-3"
                            text="Know More"
                            path="2nd-career-for-women"
                        />
                    </div>
                </div>
            </div>
            <div className="pt-3 g-background-color">
                <div className="col-xl-12 col-lg-12 mx-auto text-center ">
                    <div className="title-section title-section text-center">
                        <h3 className="title pb-1">
                            <span>
                                <i>Life at </i>
                            </span>
                            <span className="g-color ">
                                <i>NeoGrowth</i>
                            </span>
                        </h3>
                        <p className="pb-4 d-color">
                            We believe that happy and healthy employees make the
                            happy and healthy workplace. Our offerings to
                            employees go beyond the monetary benefits.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

lanMainContainer.propTypes = {
    classOption: PropTypes.string,
    mainData: PropTypes.array,
};

export default lanMainContainer;
